// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"d756be93","570":"d756be93","992":"d756be93"}[chunkId] + ".chunk.css";
};